export const parallaxDividerOptions = {
  delay: 1,
  scale: 1.5,
  overflow: true,
  orientation: 'down',
  maxTransition: 100,
};

export const parallaxHorizontalOptions = {
  delay: 1,
  scale: 1.25,
  overflow: true,
  orientation: 'right',
  maxTransition: 50,
};

export const parallaxVerticalOptions = {
  delay: 1,
  scale: 1.5,
  overflow: true,
  orientation: 'up',
  maxTransition: 100,
};
